import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FetcherService } from './fetcher/fetcher.service';
import { CreatePrototypeInput } from '@cpak/adp-cpak-quotes-service-models';
import { CreatePrototypeResponsePayload } from '@cpak/adp-cpak-bff-service-models';
import { GetPrototypeByIdResponsePayload } from '@cpak/adp-cpak-bff-service-models';

@Injectable({
  providedIn: 'root',
})
export class PrototypeService {
  constructor(private fetcher: FetcherService) {}

  public getPrototypeData(id: string): Observable<GetPrototypeByIdResponsePayload | null> {
    return this.fetcher.get(`/api/pages/prototypes/${id}`);
  }

  public createPrototype(body: CreatePrototypeInput): Observable<CreatePrototypeResponsePayload | null> {
    return this.fetcher.put(`/api/pages/prototypes`, body);
  }

  public deletePrototype(id: string): Observable<GetPrototypeByIdResponsePayload | null> {
    return this.fetcher.delete(`/api/pages/prototypes/${id}`);
  }
}
